export const SCV_MSG_CHANNEL_NAME = 'scv-msg';
